import { lazyFetchMeetingInsights } from 'owa-meeting-insights';
import {
    isInsightsEnabledForEvent,
    InsightsDataFetchSource,
} from 'owa-meeting-insights-types-and-flights';
import { ClientItemId } from 'owa-client-ids';

export function tryFetchAgendaViewMeetingInsights(id: ClientItemId | null) {
    if (id && isInsightsEnabledForEvent(id.Id)) {
        lazyFetchMeetingInsights
            .importAndExecute(id.Id, InsightsDataFetchSource.AgendaView)
            .catch(() => {
                /*
                 * fetchMeetingInsights has to return a rejected promise to tell if the task is completed or not, for the TaskQueue to schedule the next fetch task.
                 * The catch is to swallow the thrown error from fetchMeetingInsights. No need to handle the error as it is already logged inside fetchMeetingInsights.
                 */
            });
    }
}
